import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslationModule } from '@lib/translation';
import { SnIconModule } from '@lib/ui/icon';

import {
  SnPlayerComponent,
  SnPlayerFooterRowComponent,
  SnPlayerFooterSectionComponent,
} from './components';
import {
  SnPlayerPlayControl,
  SnPlayerTimeControl,
  SnPlayerHlsTimeControl,
  SnPlayerVolumeControl,
  PlayerProgressComponent,
  SnPlayerFullscreenControl,
  SnPlayerProgressBarControl,
  SnPlayerSourceToggleControl,
} from './controls';
import {
  SnPlayerGroupDirective,
  SnPlayerFooterDirective,
  SnPlayerContentDirective,
  SnPlayerPtzDirective,
  SnPlayerTimestampDirective,
} from './directives';

@NgModule({
  imports: [CommonModule, FormsModule, TranslationModule, SnIconModule],
  exports: [
    // Modules
    TranslationModule,
    // Components
    SnPlayerComponent,
    SnPlayerFooterRowComponent,
    SnPlayerFooterSectionComponent,
    // Directives
    SnPlayerGroupDirective,
    SnPlayerFooterDirective,
    SnPlayerContentDirective,
    SnPlayerPtzDirective,
    SnPlayerTimestampDirective,
    // Controls
    SnPlayerPlayControl,
    SnPlayerTimeControl,
    SnPlayerHlsTimeControl,
    SnPlayerVolumeControl,
    SnPlayerFullscreenControl,
    SnPlayerProgressBarControl,
    SnPlayerSourceToggleControl,
  ],
  declarations: [
    // Components
    PlayerProgressComponent,
    SnPlayerComponent,
    SnPlayerFooterRowComponent,
    SnPlayerFooterSectionComponent,
    // Directives
    SnPlayerGroupDirective,
    SnPlayerFooterDirective,
    SnPlayerContentDirective,
    SnPlayerPtzDirective,
    SnPlayerTimestampDirective,
    // Controls
    SnPlayerPlayControl,
    SnPlayerTimeControl,
    SnPlayerHlsTimeControl,
    SnPlayerVolumeControl,
    SnPlayerFullscreenControl,
    SnPlayerProgressBarControl,
    SnPlayerSourceToggleControl,
  ],
})
export class SnPlayerCommonModule {}
